import Image from "next/image";
import { cn } from "../lib/utils";

export interface PeekSlide {
  src: string;
  alt?: string;
}

/**
 * Horizontal snap gallery with the next image peeking — the product-page
 * pattern for image sets on smaller viewports. Slides at 85% width, scroll
 * snapping, no chrome.
 */
export function PeekSlider({
  slides,
  className,
  slideClassName,
  fit = "cover",
}: {
  slides: PeekSlide[];
  className?: string;
  slideClassName?: string;
  /** "cover" crops every slide to 4:3; "natural" keeps each image's own
   * ratio (row grows to the tallest slide, shorter ones center). */
  fit?: "cover" | "natural";
}) {
  if (!slides.length) return null;
  return (
    <div
      className={cn(
        "flex w-full snap-x snap-mandatory items-center gap-3 overflow-x-auto rounded-xl pb-2",
        className,
      )}
    >
      {slides.map((slide, index) => (
        <div key={index} className="w-[85%] shrink-0 snap-center">
          <Image
            src={slide.src}
            alt={slide.alt ?? ""}
            height={700}
            width={700}
            className={cn(
              "w-full rounded-xl",
              fit === "cover" ? "aspect-[4/3] object-cover" : "h-auto",
              slideClassName,
            )}
            loading={index === 0 ? "eager" : "lazy"}
          />
        </div>
      ))}
    </div>
  );
}
